import React from 'react';

export default () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
      <path
        d="M6 8.66663C7.10457 8.66663 8 7.7712 8 6.66663C8 5.56206 7.10457 4.66663 6 4.66663C4.89543 4.66663 4 5.56206 4 6.66663C4 7.7712 4.89543 8.66663 6 8.66663Z"
        fill="#261B36"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.66663C12 10.6666 6 15.3333 6 15.3333C6 15.3333 0 10.6666 0 6.66663C0 2.99996 2.68629 0.666626 6 0.666626C9.31371 0.666626 12 2.99996 12 6.66663ZM10.6667 6.66663C10.6667 7.34751 10.4052 8.15727 9.9004 9.05461C9.40257 9.93964 8.7207 10.8172 8.00894 11.608C7.30105 12.3946 6.58882 13.0676 6.05168 13.5451L6 13.5909L5.94832 13.5451C5.41118 13.0676 4.69895 12.3946 3.99106 11.608C3.2793 10.8172 2.59743 9.93964 2.0996 9.05461C1.59485 8.15727 1.33333 7.34751 1.33333 6.66663C1.33333 3.78793 3.37 1.99996 6 1.99996C8.63 1.99996 10.6667 3.78793 10.6667 6.66663Z"
        fill="#261B36"
      />
    </svg>
  );
};
